import { storagePlanId } from './sessionData';

// Id de plan -> keys de las secciones que ese plan NO incluye.
// Las keys son las mismas que usa indicadoresOcultosPorUsuario en el store.
// Para restringir una sección nueva, agregar su key a la lista del plan.
const seccionesSinAccesoPorPlan = {
  32: [
    'gastosDelMes',
    'gastosPorCategoria',
    'pagosDelMes',
    'chequesEmitidos',
    'deudaPorCategoriaDeCliente',
    'deudaPorCategoriaDeProveedor',
    'plazoMedioVencAPagar',
    'promDiasDePagos'
  ]
};

export const seccionRestringidaPorPlan = (key) => {
  const secciones = seccionesSinAccesoPorPlan[storagePlanId()];
  return !!secciones && secciones.includes(key);
};
